import { render, staticRenderFns } from "./entity-list.vue?vue&type=template&id=2feb23f9&"
import script from "./entity-list.vue?vue&type=script&lang=js&"
export * from "./entity-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports